<div *ngIf="isOpen" class="fixed inset-0 flex items-center justify-center" style="z-index: 99999;">
  <!-- Backdrop -->
  <div class="fixed inset-0 bg-black/50" (click)="close()"></div>

  <!-- Dialog — golden border -->
  <div class="relative bg-white shadow-2xl w-[92vw] max-w-[650px] max-h-[85vh] flex flex-col"
    style="z-index: 100000; border: 4px solid #c5a55a; font-family: sans-serif;">

    <!-- Header -->
    <div class="text-center pt-6 pb-3 px-6 shrink-0">
      <h3 class="text-xl font-bold text-gray-900" style="font-family: 'Roboto Slab', serif;">Image of the subject</h3>
      <p class="text-sm text-gray-500 mt-1">Please select the image file to be uploaded</p>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto px-6 pb-4">

      <!-- Drop zone (dashed cyan oval) -->
      <div (click)="fileInput.click()"
        class="relative mx-auto max-w-[450px] py-10 text-center cursor-pointer"
        style="border: 3px dashed #5bb8d4; border-radius: 50%; margin-top: 8px; margin-bottom: 12px;">
        <button type="button"
          class="bg-[#8B1A1A] text-white px-10 py-3 text-sm font-bold uppercase tracking-[0.2em] hover:bg-[#6d1414] transition-all mb-3">
          SELECT
        </button>
        <p class="text-sm text-[#5bb8d4] font-medium">Drag and drop images here or click to browse</p>
      </div>
      <input #fileInput type="file" accept="image/*" multiple (change)="onFileSelected($event)" class="hidden" />

      <!-- Error -->
      <p *ngIf="uploadError" class="text-xs text-red-500 mt-1 mb-2 bg-red-50 px-3 py-2 rounded text-center">{{ uploadError }}</p>

      <!-- Min resolution note -->
      <p class="text-xs text-gray-500 text-center mt-1">
        Each image must be a minimum of 750x450 or 450x750 resolution to ensure a high quality print.
      </p>

      <!-- Preview selected files -->
      <div *ngIf="uploadingFiles.length > 0" class="mt-4">
        <p class="text-xs font-bold text-gray-700 mb-2">Selected Files</p>
        <div class="flex gap-3 flex-wrap">
          <div *ngFor="let file of uploadingFiles; let i = index"
            class="relative w-[90px] h-[90px] border border-gray-200 rounded overflow-hidden shadow-sm">
            <img [src]="file.path" class="w-full h-full object-cover" />
            <button (click)="removeUploadFile(i)"
              class="absolute top-1 right-1 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center text-[10px] shadow hover:bg-red-600">
              ✕
            </button>
          </div>
        </div>
      </div>

      <!-- Previously uploaded photos -->
      <div *ngIf="myPhotos.length > 0" class="mt-4 border-t border-gray-100 pt-3">
        <p class="text-xs font-bold text-gray-700 mb-2">Previously Uploaded — Click to use</p>
        <div class="flex gap-2 flex-wrap">
          <div *ngFor="let photo of myPhotos; let i = index"
            class="relative w-[70px] h-[70px] border-2 border-gray-200 rounded overflow-hidden cursor-pointer hover:border-[#8B1A1A] transition-colors shadow-sm"
            (click)="useExistingPhoto(photo)">
            <img [src]="photo" class="w-full h-full object-cover" />
            <button (click)="removePhoto(i, $event)"
              class="absolute top-0.5 right-0.5 w-4 h-4 bg-black/50 text-white rounded-full flex items-center justify-center text-[8px] hover:bg-black/80">
              ✕
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer — CANCEL + UPLOAD buttons -->
    <div class="flex gap-4 justify-center px-6 py-4 border-t border-gray-200 shrink-0">
      <button (click)="close()"
        class="px-8 py-2.5 text-sm font-bold uppercase tracking-[0.15em] border border-gray-300 text-gray-600 bg-white hover:bg-gray-50 transition-colors">
        CANCEL
      </button>
      <button (click)="uploadPhotos()" [disabled]="isUploading || uploadingFiles.length === 0"
        [class]="'px-8 py-2.5 text-sm font-bold uppercase tracking-[0.15em] transition-colors '
          + (uploadingFiles.length > 0 && !isUploading ? 'bg-[#8B1A1A] text-white hover:bg-[#6d1414]' : 'bg-gray-200 text-gray-400 cursor-not-allowed')">
        {{ isUploading ? 'UPLOADING...' : 'UPLOAD' }}
      </button>
    </div>

  </div>
</div>
